
import {
  Vue,
  Component,
  Watch,
  Ref,
  Prop,
} from 'vue-property-decorator';
import {
  Dialog,
  Button,
  Row,
  Col,
  Form,
  FormItem,
  Input,
  Select,
  Option,
  Table,
  TableColumn,
  InputNumber,
  Transfer,
  Tag,
  RadioGroup,
  Radio,
  DatePicker,
} from 'element-ui';
import {
  log,
} from 'util';
import api from '@/api/exam';
import moment from 'moment';
import addOrModifyCommon from '../../../../components/common/addOrModifyCommon.vue';
import { get } from 'http';
import { watch } from 'fs';
@Component({
  components: {
    Dialog,
    Button,
    Row,
    Col,
    addOrModifyCommon,
    Form,
    FormItem,
    Input,
    Select,
    Option,
    Table,
    TableColumn,
    InputNumber,
    Transfer,
    Tag,
    RadioGroup,
    Radio,
    DatePicker,
  },
})
export default class addOrModify extends Vue {
  @Ref('questionForm') readonly questionFormView!: Form;

  @Prop() backCallback!: Function;

  @Prop({
    type: Boolean,
    default: false,
  }) isEdit!: boolean;

  @Prop({
    type: String,
    default: false,
  }) title!: string;

  @Prop({
    type: String,
    default: false,
  }) testIds!: string;

  @Prop({
    type: Number,
    default: false,
  }) examTime!: number;

  @Prop({
    type: String,
    default: false,
  }) examStartTime!: string;

  @Prop({
    type: String,
    default: false,
  }) examEndTime!: string;

  @Prop({
    type: String,
    default: false,
  }) examName!: string;

  @Prop({
    type: String,
    default: false,
  }) examDes!: string;

  @Prop({
    type: String,
    default: false,
  }) testType!: string;

  @Prop({
    type: String,
    default: false,
  }) testPaperId!: string;

  @Prop({
    type: String,
    default: false,
  }) testTargetUser!: string;


  private paperList: Array < any > = Array.of();

  private userNameSearch: string = '';

  // private startTime: string = '';

  // private endTime: string = '';

  private richEditor: any = {
    dialogVisible: false,
    object: null,
    parameterName: '',
    instance: null,
  };

  private questionForm: any = {
    name: '',
    time: '',
    describe: '',
    type: '',
    startTime: '',
    endTime: '',
  };

  private examPeopleType: number = 0;

  private examType: number = 0;


  // private title: string = '考试添加';

  private isNeedAddOrModify = false;

  private isLoading = false;

  private rules: any = {
    name: [{
      required: true,
      message: '请输入考试名称',
    }],
    time: [{
      required: true,
      message: '请输入时长',
    }],
    type: [{
      required: true,
      message: '请选择试卷',
      trigger: "blur"
    }],
    startTime: [{
      required: true,
      message: '请输入开始时间',
      trigger: "blur"
    },],
    endTime: [{
      required: true,
      message: '请输入结束时间',
      trigger: "blur"
    }],
  };

  private paperLists: any = [];

  mounted() {
    if (this.isEdit) {
      api.getAllTestPaper().then((res: any) => {
        this.paperLists = res;
        this.isEditAndGetContent(res);
      });
      // this.isEditAndGetContent();
    }
    api.getAllTestPaper().then((res: any) => {
      this.paperLists = res;
    });
  }


  // 判断是否是修改。若修改则默认填入内容
  isEditAndGetContent(paper: any) {
    if (this.isEdit) {
      this.questionForm.name = this.examName;
      this.questionForm.describe = this.examDes;
      this.questionForm.time = this.examTime;
      this.questionForm.startTime = this.examStartTime;
      this.questionForm.endTime = this.examEndTime;
      this.paperLists = paper.filter((item: any) => item.id === this.testPaperId);
      this.questionForm.type = this.paperLists[0].id;
      if (this.testType === 'FORMAL') {
        this.examType = 0;
      } else {
        this.examType = 1;
      }
      if (this.testTargetUser === 'ALL') {
        this.examPeopleType = 0;
      } else {
        this.examPeopleType = 1;
      }
    }
  }

  // 添加考试
  // eslint-disable-next-line class-methods-use-this
  addTest() {
    this.questionFormView.validate((isSuccess: boolean) => {
      if (isSuccess) {
      const data = {
      paperId: this.questionForm.type,
      type: '',
      name: this.questionForm.name,
      description: this.questionForm.describe,
      totalTime: this.questionForm.time,
      beginTime: this.questionForm.startTime? moment(this.questionForm.startTime).format('YYYY-MM-DD HH:mm:ss') : '',
      // beginTime: '2020-12-19 08:00:00',
      endTime: this.questionForm.endTime? moment(this.questionForm.endTime).format('YYYY-MM-DD HH:mm:ss'): '',
      // endTime: '2020-12-19 10:00:00',
      targetUserType: 'ALL',
    };
    if (this.examType === 0) {
      data.type = 'FORMAL';
    } else if (this.examType === 1) {
      data.type = 'SIMULATION';
    }
    // if (this.examPeopleType === 0) {
    //   data.targetUserType = 'ALL';
    // } else if (this.examPeopleType === 1) {
    //   data.targetUserType = 'TARGET';
    // }
    api.addTest(data).then((res: any) => {
      this.back();
      this.isLoading = false;
    });
    }
    })
  }

  // 修改考试
  // eslint-disable-next-line class-methods-use-this
  modifyTest() {
    const data = {
      id: this.testIds,
      paperId: this.questionForm.type,
      type: '',
      name: this.questionForm.name,
      description: this.questionForm.describe,
      totalTime: this.questionForm.time,
      beginTime: this.questionForm.startTime? moment(this.questionForm.startTime).format('YYYY-MM-DD HH:mm:ss') : '',
      endTime: this.questionForm.endTime? moment(this.questionForm.endTime).format('YYYY-MM-DD HH:mm:ss'): '',
      // targetUserType: '',
      targetUserType: 'ALL'
    };
    if (this.examType === 0) {
      data.type = 'FORMAL';
    } else if (this.examType === 1) {
      data.type = 'SIMULATION';
    }
    // if (this.examPeopleType === 0) {
    //   data.targetUserType = 'ALL';
    // } else if (this.examPeopleType === 1) {
    //   data.targetUserType = 'TARGET';
    // }
    api.modifyTest(data).then((res: any) => {
      this.back();
      this.isLoading = false;
    });
  }

  back() {
    this.backCallback();
  }

  // 添加子项
  handleAdd() {
    this.paperList.push({
      radioCount: 0,
      radioScore: 0,
      multiCount: 0,
      multiScore: 0,
      judgeCount: 0,
      judgeScore: 0,
      saqCount: 0,
      saqScore: 0,
    });
  }

  removeItem(index: number) {
    this.paperList.splice(index, 1);
  }

  resetForm() {
    this.questionFormView.resetFields();
    // eslint-disable-next-line no-return-assign
    Object.keys(this.questionForm).forEach(key => this.questionForm[key] = '');
    // this.startTime = '';
    // this.endTime = '';
  }

  submitForm() {
    if (this.isEdit) {
      this.modifyTest();
    } else {
      this.addTest();
    }
    // this.questionFormView.validate((isSuccess: boolean) => {
    //   if (isSuccess) {
    //     this.isLoading = true;
    //     setTimeout(() => {
    //       this.isLoading = false;
    //       this.back();
    //     }, 2000);
    //   }
    // });
  }

  private inputContent: string = '';

  // eslint-disable-next-line no-dupe-class-members
  inputClick(object: any, parameterName: string) {
    this.inputContent = object[parameterName];
    this.richEditor.object = object;
    this.richEditor.parameterName = parameterName;
    this.richEditor.dialogVisible = true;
  }

  // eslint-disable-next-line no-dupe-class-members
  editorReady(instance: any) {
    this.richEditor.instance = instance;
    const currentContent = this.richEditor.object[this.richEditor.parameterName];
    this.richEditor.instance.setContent(currentContent);
    // 光标定位到Ueditor
    this.richEditor.instance.focus(true);
  }

  showOrCloseAdd() {
    this.richEditor.dialogVisible = true;
    this.isNeedAddOrModify = !this.isNeedAddOrModify;
  }

  editorConfirm() {
    const content = this.richEditor.instance.getContent();
    this.richEditor.object[this.richEditor.parameterName] = content;
    this.richEditor.dialogVisible = false;
  }
}
